import { render, staticRenderFns } from "./Economia.vue?vue&type=template&id=5f72e036&scoped=true&lang=pug&"
import script from "./Economia.vue?vue&type=script&lang=js&"
export * from "./Economia.vue?vue&type=script&lang=js&"
import style0 from "./Economia.styl?vue&type=style&index=0&id=5f72e036&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72e036",
  null
  
)

export default component.exports